import React from 'react';
import { Heading } from '@innovationnorway/cl-react';
import useOneWayIn from '../../../hooks/use-one-way-in';
import { useParams } from 'react-router-dom';
import { PageParams } from '../../types/PageParams';
import { useTranslation } from 'react-i18next';
import { FeltFormatert } from 'src/api/v2';

enum OWIFormGroupNames {
  Concept = 'Konseptet',
  Problem = 'Problemstilling',
  Clarification = 'Ønsket avklaring',
}

const OWIFormFieldNamesPre25 = {
  Description: ['Hvilket problem skal dere løse?'],
  Help: ['Hvilke avklaringer ønsker du å få gjennom denne henvendelsen?'],
};

const OWIFormFieldNames = {
  Description: ['Beskriv konseptet så detaljert som mulig', 'Beskriv konseptet'],
  Help: ['Hva kan vi hjelpe deg med?', 'Beskriv hva du ønsker hjelp til'],
};

const OwiFormOverview = () => {
  const { formId } = useParams<PageParams>();
  const { oneWayInGroupedFormWOEnrollmentsQuery } = useOneWayIn(formId);
  const form = oneWayInGroupedFormWOEnrollmentsQuery.data;
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  const getFormFields = (groupName: OWIFormGroupNames) =>
    form?.grupper?.find((group) => group.navn === groupName)?.felter ?? [];

  const getFormFieldValue = (groupName: OWIFormGroupNames, predicate: (field: FeltFormatert) => boolean) =>
    getFormFields(groupName).find(predicate)?.verdi;

  const getFirstFieldValueByName = (groupName: OWIFormGroupNames, fieldNames: string[]) =>
    fieldNames
      .map((fieldName) => getFormFieldValue(groupName, (field) => field.navn === fieldName))
      .find((value) => value != null);

  const conceptTextFields = getFormFields(OWIFormGroupNames.Concept).filter((field) => field.type === 'text');

  const formDescription =
    getFirstFieldValueByName(OWIFormGroupNames.Concept, OWIFormFieldNames.Description) ??
    getFirstFieldValueByName(OWIFormGroupNames.Problem, OWIFormFieldNamesPre25.Description) ??
    conceptTextFields[0]?.verdi;

  const formHelp =
    getFirstFieldValueByName(OWIFormGroupNames.Concept, OWIFormFieldNames.Help) ??
    getFirstFieldValueByName(OWIFormGroupNames.Clarification, OWIFormFieldNamesPre25.Help) ??
    conceptTextFields[1]?.verdi;

  return (
    <div className="display--flex flex-direction--column gap--ds-6 max-width--664px">
      <div className="display--flex flex-direction--column gap--ds-4">
        <Heading level={3} className="font-size--ds-5">
          {tOneWayIn('opportunityDetails.Concept')}
        </Heading>
        <span>{formDescription}</span>
      </div>
      <div className="display--flex flex-direction--column gap--ds-4">
        <Heading level={3} className="font-size--ds-5">
          {tOneWayIn('opportunityDetails.WhatCustomerNeedsHelpWith')}
        </Heading>
        <span>{formHelp}</span>
      </div>
    </div>
  );
};

export default OwiFormOverview;
